export class UserData {
  constructor(authManager = null) {
    this.auth = authManager
    this.data = this._defaults()
  }

  // Sync load from localStorage — call on startup so data is immediately available
  loadSync() {
    try {
      const raw = localStorage.getItem('td_userdata')
      if (raw) this.data = { ...this._defaults(), ...JSON.parse(raw) }
    } catch {}
    return this
  }

  // Full async load — tries remote first, falls back to localStorage
  async load() {
    if (this.auth?.isLoggedIn) {
      try {
        const remote = await this.auth.loadData()
        if (remote?.version) {
          this.data = { ...this._defaults(), ...remote }
          // Keep localStorage in sync
          localStorage.setItem('td_userdata', JSON.stringify(this.data))
          return this
        }
      } catch (e) {
        console.warn('[UserData] Remote load failed, using localStorage:', e.message)
      }
    }
    this.loadSync()
    return this
  }

  async save() {
    localStorage.setItem('td_userdata', JSON.stringify(this.data))
    if (this.auth?.isLoggedIn) {
      try {
        await this.auth.saveData(this.data)
      } catch (e) {
        console.warn('[UserData] Remote save failed:', e.message)
      }
    }
  }

  patchCampaignData(campaignsData) {
        Object.values(campaignsData).forEach(campaign => {
            if (!campaign.nodes) return
            campaign.nodes.forEach(node => {
                node.unlocked = this.isLevelUnlocked(node.levelId)
            })
        })
    }

  // ── API ───────────────────────────────────────────────────────────────────

  isLevelUnlocked(levelId) {
    return this.data.unlockedLevels.includes(levelId)
  }

  async unlockLevel(levelId) {
    if (this.isLevelUnlocked(levelId)) return
    this.data.unlockedLevels.push(levelId)
    await this.save()
  }

  getLoadout() { return [...this.data.loadout] }

  async saveLoadout(loadout) {
    this.data.loadout = [...loadout]
    await this.save()
  }

  _defaults() {
    return { version: 1, unlockedLevels: ['riverMarsh'], loadout: [] }
  }
}